export default __webpack_public_path__ + "static/media/Nikhil.8db0192a.jpg";